<mat-toolbar class="custom-header">
  <button mat-icon-button (click)="goBack()" class="back-btn-workout-exe-tutorial">
    <mat-icon *ngIf="!backLoader" svgIcon="mat:chevron_left"></mat-icon>
    <mat-progress-spinner
      *ngIf="backLoader"
      diameter="14"
      strokeWidth="2"
      mode="indeterminate"
      class="spinner-inline">
    </mat-progress-spinner>
  </button>
</mat-toolbar>
<div class="container" *ngIf="workout">
  <div class="phase-title">
    <h2>{{workout.phases[phaseNumber].i18nName[translate.currentLang.toUpperCase()]}} - {{"WORKOUT.WORKOUT-EXE.SET"|
      translate}} {{setCounter}}/{{workout.phases[phaseNumber].repetitions}}</h2>
    <span>
      <mat-icon svgIcon="mat:swap_horiz" style="margin-right: 5px;" *ngIf="workout.exerciseMap[workout.phases[phaseNumber].exercises[exerciseNumber].exerciseId]?.exerciseAlternativeId" (click)="openModalSwapExercise()"></mat-icon>
      <mat-icon svgIcon="mat:info" (click)="openModalExerciseDetail()"></mat-icon>
    </span>
  </div>
  <div class="phase-description" *ngIf="getPhaseDescription(workout.phases[phaseNumber]?.workoutPhaseTypeId)">
    {{getPhaseDescription(workout.phases[phaseNumber]?.workoutPhaseTypeId)}}
  </div>
  <div class="exercise">
    <p class="exercise-name">
      {{workout?.exerciseMap[workout.phases[phaseNumber].exercises[exerciseNumber].exerciseId].i18nName[translate.currentLang.toUpperCase()]}}
    </p>
    <img class="img-exercise" [class.hide-ex-img]="!isImageLoaded" (load)="onImageLoad()"
      [src]="environment.exercises+'/'+workout.phases[phaseNumber].exercises[exerciseNumber].exerciseId+'/images/main'">
    <div class="skeleton img-exercise-placeholder" *ngIf="!isImageLoaded"></div>
  </div>
  <div class="controls-zone">
    <div class="start" *ngIf="workoutStartTimer > 0">
      <div class="start-timer">
        {{ workoutStartTimer }}
      </div>
      <p class="ready-to-go">{{"WORKOUT.WORKOUT-EXE.READY-TO-GO"| translate}}</p>
      <button class="its-button" (click)="skipStartTimer()">{{"WORKOUT.WORKOUT-EXE.SKIP-BTN"| translate}}</button>
    </div>
    <div class="controls" *ngIf="workoutStartTimer < 1">
      <div class="d-flex">
        <div class="back-btn" (click)="previousExercise()">
          <mat-icon svgIcon="mat:keyboard_arrow_left"></mat-icon>
        </div>
        <div class="circle-container">
          <svg width="80" height="80">
            <circle cx="40" cy="40" r="36" stroke="#e6e6e6" stroke-width="5" fill="none" />
            <circle cx="40" cy="40" r="36" stroke="#db3687" stroke-width="5" fill="none"
              [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="offset" mstroke-linecap="round"
              transform="rotate(-90 40 40)" />
          </svg>
          <div class="pause-btn" *ngIf="!isWorkoutPaused" (click)="openModalStopWorkout()">
            <mat-icon svgIcon="mat:pause"></mat-icon>
          </div>
          <div class="pause-btn" *ngIf="isWorkoutPaused" (click)="resumeWorkout()">
            <mat-icon svgIcon="mat:play_arrow"></mat-icon>
          </div>
        </div>
        <div class="next-btn" (click)="nextExercise()">
          <mat-icon svgIcon="mat:keyboard_arrow_right"></mat-icon>
        </div>
      </div>
      <h2 *ngIf="remainingTime > 0" class="rem-timer-tutorial">{{remainingTime * 1000 | date: 'mm:ss'}}</h2>
      <h2 class="reps-number" *ngIf="workout.phases[phaseNumber].exercises[exerciseNumber].repetitions > 0">
        {{workout.phases[phaseNumber].exercises[exerciseNumber].repetitions}}
        {{"WORKOUT.WORKOUT-EXE.REPS" | translate}}
        <span *ngIf="workout.phases[phaseNumber].exercises[exerciseNumber].eachSideFlag">
          {{"WORKOUT.WORKOUT-EXE.SIDE"| translate}}
        </span>
      </h2>
      <span *ngIf="remainingTime > 0">
        <p *ngIf="workout.phases[phaseNumber].exercises[exerciseNumber].eachSideFlag && eachSideView === 0">
          {{"WORKOUT.WORKOUT-EXE.LX_SIDE"| translate}}</p>
        <p *ngIf="workout.phases[phaseNumber].exercises[exerciseNumber].eachSideFlag && eachSideView === 1">
          {{"WORKOUT.WORKOUT-EXE.RX_SIDE"| translate}}</p>
      </span>
      <a (click)="openModalRegisterWeight()" *ngIf="canRegisterWeight()">{{"WORKOUT.WORKOUT-EXE.REGISTER-WEIGHT"|
        translate}}</a>
    </div>
  </div>
  <div class="next-exercise-container" *ngIf="workoutStartTimer < 1 && nextExercisePreview()">
    <h2>{{"WORKOUT.WORKOUT-EXE.NEXT-EXE"| translate}}</h2>

    <div class="next-exercise"
      *ngIf="nextExercisePreview().exerciseId">
      <ion-thumbnail>
        <img (load)="onImageNextLoad()" [hidden]="!isImageNextLoaded"
          [src]="environment.exercises+'/'+nextExercisePreview().exerciseId+'/images/main'">
        <div class="skeleton" *ngIf="!isImageLoaded"></div>
      </ion-thumbnail>
      <p class="exercise-name">
        {{workout.exerciseMap[nextExercisePreview().exerciseId].i18nName[translate.currentLang.toUpperCase()]}}
      </p>
    </div>
  </div>
</div>
